import {FulfillmentType} from '@frontend/directus';
import {ProvisioningType} from '@frontend/shared-api';

export enum AnswerDisplayKind {
  ABSENT = 'ABSENT',
  TWO_STAGE = 'TWO_STAGE',
  LABEL = 'LABEL',
  NUMBER = 'NUMBER',
}

export interface AnswerDisplay {
  kind: AnswerDisplayKind;
  labelKey?: string;
  capabilityKey?: string;
  provisioningKey?: string;
  score?: number;
}

export interface AnswerValue {
  score?: number;
  scoreAbsent?: boolean;
  capabilityLevel?: number;
  provisioningType?: ProvisioningType;
}

const TERNARY_LABEL_KEYS: ReadonlyMap<number, string> = new Map([
  [1, 'provider.tenderResponse.fulfillmentScore.full'],
  [0.5, 'provider.tenderResponse.fulfillmentScore.partly'],
  [0, 'provider.tenderResponse.fulfillmentScore.none'],
]);

const BOOLEAN_LABEL_KEYS: ReadonlyMap<number, string> = new Map([
  [1, 'common.yes'],
  [0, 'common.no'],
]);

export function describeAnswer(
  twoStage: boolean,
  fulfillmentType: FulfillmentType | undefined,
  value: AnswerValue,
): AnswerDisplay | null {
  if (value.scoreAbsent) {
    return {kind: AnswerDisplayKind.ABSENT};
  }
  if (value.score === undefined || value.score === null) {
    return null;
  }
  if (
    twoStage &&
    value.capabilityLevel !== undefined &&
    value.capabilityLevel !== null &&
    value.provisioningType
  ) {
    return {
      kind: AnswerDisplayKind.TWO_STAGE,
      capabilityKey: `provider.tenderResponse.twoStage.capability.level${value.capabilityLevel}`,
      provisioningKey: `provider.tenderResponse.twoStage.provisioning.${value.provisioningType}`,
      score: value.score,
    };
  }
  const labelKey = labelKeyFor(fulfillmentType, value.score);
  return labelKey
    ? {kind: AnswerDisplayKind.LABEL, labelKey}
    : {kind: AnswerDisplayKind.NUMBER, score: value.score};
}

function labelKeyFor(fulfillmentType: FulfillmentType | undefined, score: number): string | null {
  switch (fulfillmentType) {
    case FulfillmentType.TERNARY:
      return TERNARY_LABEL_KEYS.get(score) ?? null;
    case FulfillmentType.BOOLEAN:
      return BOOLEAN_LABEL_KEYS.get(score) ?? null;
    default:
      return null;
  }
}
